<template>
    <button ref="button" :class="colors[color]" class="relative px-[35px] h-[50px] transition-all flex items-center justify-center gap-x-[10px] font-semibold">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: 'ButtonComponent',
        props: {
            color: {
                Type: String,
                Default: 'violet',
                require: false
            }
        },
        data() {
            return {
                colors: {
                    rose: 'bg-rose text-white hover:bg-rose-700 border-[4px] border-[transparent] active:border-rose-200',
                    transperent: 'text-white border border-[1px solid #fff] ',
                    black: 'text-black border',
                },
            }
        }
    }
</script>